import { Product } from './types';

export const LOGO_URL = 'https://ik.imagekit.io/sbsjhivv8/Devinestone?updatedAt=1772535820763';

export const GOOGLE_CLIENT_ID = (import.meta as any).env?.VITE_GOOGLE_CLIENT_ID || '';

export const RAZORPAY_KEY_ID = (import.meta as any).env?.VITE_RAZORPAY_KEY_ID || '';

// ImageKit constants (admin-only, VITE_ prefix for client-side security)
export const IMAGEKIT_URL_ENDPOINT = (import.meta as any).env?.VITE_IMAGEKIT_URL_ENDPOINT || '';
export const IMAGEKIT_PUBLIC_KEY = (import.meta as any).env?.VITE_IMAGEKIT_PUBLIC_KEY || '';
export const IMAGEKIT_PRIVATE_KEY = (import.meta as any).env?.VITE_IMAGEKIT_PRIVATE_KEY || '';

// Success Sound URL
export const SUCCESS_SOUND_URL = 'https://assets.mixkit.co/active_storage/sfx/2013/2013-preview.mp3';
